import {
  SurveyCustomerExperienceOptions,
  SurveyMediaChecklistOptions,
} from './appointmentProposalSurveyOptions.models';

export interface AppointmentProposalSurveyOptionsState {
  customerExperienceOptions: {
    current: SurveyCustomerExperienceOptions[];
    priorities: SurveyCustomerExperienceOptions[];
  };
  mediaChecklistOptions: SurveyMediaChecklistOptions;
  isLoading: boolean;
  isLoaded: boolean;
  error: string | null;
}

type Action =
  | { type: 'FETCH_SURVEY_OPTIONS' }
  | {
      type: 'FETCH_SURVEY_OPTIONS_SUCCESS';
      payload: {
        customerExperienceOptions: AppointmentProposalSurveyOptionsState['customerExperienceOptions'];
        mediaChecklistOptions: SurveyMediaChecklistOptions;
      };
    }
  | { type: 'FETCH_SURVEY_OPTIONS_FAILURE'; payload: { error: string } }
  | {
      type: 'SET_LOADING_STATE';
      payload: { isLoading: boolean; isLoaded: boolean };
    };

export const initialState: AppointmentProposalSurveyOptionsState = {
  customerExperienceOptions: {
    current: [],
    priorities: [],
  },
  mediaChecklistOptions: {
    indoor: [],
    outdoor: [],
  },
  isLoading: true,
  isLoaded: false,
  error: null,
};

export const proposalBuilderSurveyOptionsReducer = (
  state: AppointmentProposalSurveyOptionsState,
  action: Action
): AppointmentProposalSurveyOptionsState => {
  switch (action.type) {
    case 'FETCH_SURVEY_OPTIONS':
      return {
        ...state,
        isLoading: true,
        isLoaded: !!(
          state.customerExperienceOptions.current.length &&
          state.customerExperienceOptions.priorities.length
        ),
        error: null,
      };
    case 'FETCH_SURVEY_OPTIONS_SUCCESS':
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        customerExperienceOptions: action.payload.customerExperienceOptions,
        mediaChecklistOptions: action.payload.mediaChecklistOptions,
      };
    case 'FETCH_SURVEY_OPTIONS_FAILURE':
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload.error,
      };

    case 'SET_LOADING_STATE':
      return { ...state, ...action.payload };

    default:
      return state;
  }
};
